// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog-content {
  width: 100%;
}

.alinging-textbox-two {
  display: flex;
  width: 100% !important;
}

.main-heading {
  font-size: 25px !important;
  font-weight: 400;
}

.title-link {
  margin-left: 2rem;
  font-size: 25px !important;
}

.image-box {
  border: 2px solid #555;
  width: 100%;
  height: 425px !important;
  text-align: center;
}
.image-box .image-text {
  line-height: 425px;
  font-size: 30px !important;
  font-weight: 600;
}

.image {
  border: 2px solid #555;
}

.stepper {
  display: flex;
  width: 100% !important;
}
.stepper .stepper-span {
  margin-right: 1rem !important;
  margin-top: 1.5rem !important;
}
.stepper .stepper-textfield {
  width: 395px !important;
  margin-top: 0.5rem !important;
}

.alinging-textfield-two {
  display: flex;
  width: 100% !important;
}
.alinging-textfield-two .textfield-two {
  margin-right: 2rem !important;
  margin-top: 5rem !important;
  width: 50% !important;
}
.alinging-textfield-two .textfield-three {
  width: 30% !important;
  margin-right: 5rem;
  margin-top: 0.7rem;
}
.alinging-textfield-two .edit-textfield-var {
  width: 8% !important;
  margin-right: 2rem !important;
  margin-top: 0.7rem !important;
}

.align-iframe-tabid {
  display: flex;
  width: 100% !important;
  align-items: end;
}
.align-iframe-tabid .textfield-iframe {
  margin-right: 1rem !important;
  margin-top: 0.7rem !important;
  width: 45% !important;
}
.align-iframe-tabid .textfield-IP {
  margin-right: 1rem !important;
  margin-top: 0.7rem !important;
  width: 45% !important;
}
.align-iframe-tabid .edit-select-tabs {
  width: 10% !important;
  margin-top: 0.7rem;
  margin-right: 1rem !important;
}

.alert {
  width: 20%;
  position: fixed;
  top: 45%;
  right: 40%;
  left: 40%;
  bottom: 45%;
  z-index: 999;
  background-color: #0FC6EE !important;
  color: black !important;
  font-weight: 800 !important;
  font-size: 18px !important;
}

.delete-alert {
  width: 50%;
  max-width: 400px; /* Adjust max-width to suit your design */
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
  background-color: #0fc6ee !important;
  color: black !important;
  font-weight: 800 !important;
  font-size: 20px !important;
}

.delete-text {
  display: block;
  margin-bottom: 1rem;
}

.button-container {
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
}

.delete-button-yes,
.delete-button-no {
  flex: 1 1;
  margin: 0 0.5rem;
  background-color: black !important;
  color: #0fc6ee;
}

/* Add margin between buttons */
.delete-button-yes + .delete-button-no {
  margin-left: 2rem;
}

.alinging-textbox-for-edit {
  display: flex;
  width: 100% !important;
}
.alinging-textbox-for-edit .edit-all-select {
  display: flex;
  width: 50% !important;
}
.alinging-textbox-for-edit .edit-all-select .edit-select-addStep {
  width: 20% !important;
  margin-right: 1rem;
  margin-top: 0.25rem;
}
.alinging-textbox-for-edit .edit-all-select .edit-select-keyword {
  width: 20% !important;
  margin-right: 1rem;
  margin-top: 0.25rem;
}
.alinging-textbox-for-edit .edit-all-select .edit-select-action {
  width: 20% !important;
  margin-right: 1rem;
  margin-top: 0.25rem;
}
.alinging-textbox-for-edit .edit-all-select .edit-select-Options {
  width: 20% !important;
  margin-right: 1rem;
  margin-top: 0.25rem;
}
.alinging-textbox-for-edit .edit-all-select .edit-select-flow {
  width: 20% !important;
  margin-right: 1rem;
  margin-top: 0.25rem;
}
.alinging-textbox-for-edit .edit-all-textfield {
  display: flex;
  width: 100% !important;
}
.alinging-textbox-for-edit .edit-all-textfield .edit-textfield-Wait {
  width: 10% !important;
  margin-right: 1rem;
  margin-top: 0.25rem;
}
.alinging-textbox-for-edit .edit-all-textfield .edit-textfield-Waittime {
  width: 10% !important;
  margin-right: 1rem;
  margin-top: 0.25rem;
}
.alinging-textbox-for-edit .edit-all-textfield .edit-textfield-pd {
  width: 30% !important;
  margin-right: 1rem;
  margin-top: 0.25rem;
}
.alinging-textbox-for-edit .edit-all-textfield .textfield-type {
  width: 12.5% !important;
  margin-right: 1rem;
  margin-top: 0.25rem;
}
.alinging-textbox-for-edit .edit-all-textfield .edit-textfield-img {
  width: 12.5% !important;
  margin-right: 1rem;
  margin-top: 0.25rem;
}
.alinging-textbox-for-edit .edit-all-textfield .edit-textfield-BG {
  width: 12.5% !important;
  margin-right: 1rem;
  margin-top: 0.25rem;
}
.alinging-textbox-for-edit .edit-all-textfield .edit-textfield-threshold {
  width: 12.5% !important;
  margin-right: 1rem;
  margin-top: 0.25rem;
}

.edit-all-secondrow {
  display: flex;
  width: 100% !important;
  margin-top: 1rem;
  align-content: flex-end;
}
.edit-all-secondrow .dropdown-search {
  height: 10%;
  margin-right: 1rem !important;
  margin-top: 0.7rem !important;
}
.edit-all-secondrow .textfield-OI {
  width: 45% !important;
  margin-right: 1rem !important;
}
.edit-all-secondrow .textfield-TD {
  width: 45% !important;
  margin-right: 1rem !important;
  margin-top: 0.7rem !important;
}
.edit-all-secondrow .edit-textfield-var {
  width: 10% !important;
  margin-right: 1rem !important;
  margin-top: 0.7rem !important;
}

.modal-expand {
  margin-top: 1rem;
}

.custom-dialog .css-1t1j96h-MuiPaper-root-MuiDialog-paper {
  background-color: #C3D2EB;
}

.header-textfield .css-1ff8729-MuiInputBase-root-MuiFilledInput-root {
  background-color: #D3DDE6 !important;
}

.box-mui ::-webkit-scrollbar {
  display: block;
  width: 0.5rem;
  height: 50px;
}
.box-mui ::-webkit-scrollbar-thumb {
  background-color: #0FC6EE;
  min-height: 50px;
}`, "",{"version":3,"sources":["webpack://./src/components/RecordingTable/RecordingTable.style.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;AACJ;;AAEA;EACI,0BAAA;EACA,gBAAA;AACJ;;AAEA;EACI,iBAAA;EACA,0BAAA;AACJ;;AAEA;EACI,sBAAA;EACA,WAAA;EACA,wBAAA;EACA,kBAAA;AACJ;AAAI;EACI,kBAAA;EACA,0BAAA;EACA,gBAAA;AAER;;AAEA;EACI,sBAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;AACJ;AAAI;EACI,6BAAA;EACA,6BAAA;AAER;AAAI;EACI,uBAAA;EACA,6BAAA;AAER;;AAEA;EACI,aAAA;EACA,sBAAA;AACJ;AAAI;EACI,6BAAA;EACA,2BAAA;EACA,qBAAA;AAER;AACI;EACI,qBAAA;EACI,kBAAA;EACA,kBAAA;AACZ;AAGI;EACI,oBAAA;EACA,6BAAA;EACA,6BAAA;AADR;;AAKA;EACI,aAAA;EACA,sBAAA;EACA,gBAAA;AAFJ;AAGI;EACI,6BAAA;EACA,6BAAA;EACA,qBAAA;AADR;AAGI;EACI,6BAAA;EACA,6BAAA;EACA,qBAAA;AADR;AAGI;EACI,qBAAA;EACA,kBAAA;EACA,6BAAA;AADR;;AAMA;EACI,UAAA;EACA,eAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,uBAAA;EACA,2BAAA;EACA,0BAAA;AAHJ;;AAKA;EACI,UAAA;EACA,gBAAA,EAAA,yCAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,YAAA;EACA,oCAAA;EACA,uBAAA;EACA,2BAAA;EACA,0BAAA;AAFJ;;AAKE;EACE,cAAA;EACA,mBAAA;AAFJ;;AAKE;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;AAFJ;;AAKE;;EAEE,SAAA;EACA,gBAAA;EACA,kCAAA;EACA,cAAA;AAFJ;;AAKE,+BAAA;AACF;EACI,iBAAA;AAFJ;;AAKA;EACI,aAAA;EACA,sBAAA;AAFJ;AAGI;EACI,aAAA;EACA,qBAAA;AADR;AAEQ;EACI,qBAAA;EACA,kBAAA;EACA,mBAAA;AAAZ;AAEQ;EACI,qBAAA;EACA,kBAAA;EACA,mBAAA;AAAZ;AAEQ;EACI,qBAAA;EACA,kBAAA;EACA,mBAAA;AAAZ;AAEQ;EACI,qBAAA;EACA,kBAAA;EACA,mBAAA;AAAZ;AAEQ;EACI,qBAAA;EACA,kBAAA;EACA,mBAAA;AAAZ;AAMA;EACQ,aAAA;EACA,sBAAA;AAJR;AAKQ;EACI,qBAAA;EACA,kBAAA;EACD,mBAAA;AAHX;AAKQ;EACI,qBAAA;EACA,kBAAA;EACA,mBAAA;AAHZ;AAKQ;EACI,qBAAA;EACA,kBAAA;EACA,mBAAA;AAHZ;AAKQ;EACI,uBAAA;EACA,kBAAA;EACA,mBAAA;AAHZ;AAKO;EACK,uBAAA;EACA,kBAAA;EACA,mBAAA;AAHZ;AAKO;EACI,uBAAA;EACA,kBAAA;EACA,mBAAA;AAHX;AAKQ;EACI,uBAAA;EACA,kBAAA;EACA,mBAAA;AAHZ;;AAQA;EACI,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,uBAAA;AALJ;AAMI;EACI,WAAA;EACA,6BAAA;EACA,6BAAA;AAJR;AAMI;EACI,qBAAA;EACA,6BAAA;AAJR;AAYI;EACI,qBAAA;EACA,6BAAA;EACA,6BAAA;AAVR;AAaI;EACI,qBAAA;EACA,6BAAA;EACA,6BAAA;AAXR;;AAmBA;EACI,gBAAA;AAhBJ;;AAoBI;EACI,yBAAA;AAjBR;;AAwBI;EACI,oCAAA;AArBR;;AAyBI;EACI,cAAA;EACA,aAAA;EACA,YAAA;AAtBR;AAwBI;EACI,yBAAA;EACA,gBAAA;AAtBR","sourcesContent":[".dialog-content{\n    width: 100%;\n}\n\n.alinging-textbox-two{\n    display: flex;\n    width: 100% !important;\n}\n\n.main-heading{\n    font-size: 25px !important;\n    font-weight: 400;\n}\n\n.title-link{\n    margin-left: 2rem;\n    font-size: 25px !important;\n}\n\n.image-box{\n    border: 2px solid #555;\n    width: 100%;\n    height: 425px !important;\n    text-align: center;\n    .image-text{\n        line-height: 425px;\n        font-size: 30px !important;\n        font-weight: 600;\n    }\n}\n\n.image{\n    border: 2px solid #555\n}\n\n.stepper{\n    display: flex;\n    width: 100% !important;\n    .stepper-span{\n        margin-right: 1rem !important;\n        margin-top: 1.5rem !important;\n    }\n    .stepper-textfield{\n        width: 395px !important;\n        margin-top: 0.5rem !important;\n    }\n}\n\n.alinging-textfield-two{\n    display: flex;\n    width: 100% !important;\n    .textfield-two{\n        margin-right: 2rem !important;\n        margin-top: 5rem !important;\n        width: 50% !important;\n       \n    }\n    .textfield-three{\n        width: 30% !important;\n            margin-right: 5rem;    \n            margin-top: 0.7rem;  \n          \n       \n    }\n    .edit-textfield-var{\n        width:8% !important;\n        margin-right: 2rem !important;\n        margin-top: 0.7rem !important;   \n      }\n     }\n\n.align-iframe-tabid{\n    display: flex;\n    width: 100% !important;\n    align-items: end;\n    .textfield-iframe{\n        margin-right: 1rem !important;\n        margin-top: 0.7rem !important;\n        width: 45% !important;\n    }\n    .textfield-IP{\n        margin-right: 1rem !important;\n        margin-top: 0.7rem !important;\n        width: 45% !important;\n    }\n    .edit-select-tabs{\n        width: 10% !important;   \n        margin-top: 0.7rem;  \n        margin-right: 1rem !important;           \n    }\n    \n   \n}\n.alert{\n    width: 20%;\n    position: fixed;\n    top: 45%;\n    right: 40%;\n    left: 40%;\n    bottom: 45%;\n    z-index: 999;\n    background-color: #0FC6EE !important;\n    color: black !important;\n    font-weight: 800 !important;\n    font-size: 18px !important;\n}\n.delete-alert {\n    width: 50%;\n    max-width: 400px; /* Adjust max-width to suit your design */\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    z-index: 999;\n    background-color: #0fc6ee !important;\n    color: black !important;\n    font-weight: 800 !important;\n    font-size: 20px !important;\n  }\n  \n  .delete-text {\n    display: block;\n    margin-bottom: 1rem;\n  }\n  \n  .button-container {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 1rem;\n  }\n  \n  .delete-button-yes,\n  .delete-button-no {\n    flex: 1;\n    margin: 0 0.5rem;\n    background-color: black !important;\n    color: #0fc6ee;\n  }\n\n  /* Add margin between buttons */\n.delete-button-yes + .delete-button-no {\n    margin-left: 2rem;\n  }\n\n.alinging-textbox-for-edit{\n    display: flex;\n    width: 100% !important;\n    .edit-all-select{\n        display: flex;\n        width: 50% !important;\n        .edit-select-addStep{\n            width: 20% !important;\n            margin-right: 1rem;\n            margin-top: 0.25rem;\n        }\n        .edit-select-keyword{\n            width: 20% !important;\n            margin-right: 1rem;  \n            margin-top: 0.25rem;\n        }\n        .edit-select-action{\n            width: 20% !important;\n            margin-right: 1rem;    \n            margin-top: 0.25rem;\n        }\n        .edit-select-Options{\n            width: 20% !important;\n            margin-right: 1rem;    \n            margin-top: 0.25rem;\n        }\n        .edit-select-flow{\n            width: 20% !important;\n            margin-right: 1rem;    \n            margin-top: 0.25rem;  \n        }\n    }\n\n\n\n.edit-all-textfield{\n        display: flex;\n        width: 100% !important;\n        .edit-textfield-Wait{\n            width: 10% !important;\n            margin-right: 1rem;\n           margin-top: 0.25rem;   \n           }\n        .edit-textfield-Waittime{\n            width: 10% !important;\n            margin-right: 1rem;\n            margin-top: 0.25rem;      \n        }\n        .edit-textfield-pd{\n            width:30% !important;\n            margin-right: 1rem;\n            margin-top: 0.25rem;   \n        }\n        .textfield-type{\n            width:12.5% !important;\n            margin-right: 1rem;\n            margin-top: 0.25rem;   \n        }\n       .edit-textfield-img{\n            width:12.5% !important;\n            margin-right: 1rem;\n            margin-top: 0.25rem;   \n       }\n       .edit-textfield-BG{\n           width:12.5% !important;\n           margin-right: 1rem;\n           margin-top: 0.25rem;   \n       }\n        .edit-textfield-threshold{\n            width: 12.5% !important;\n            margin-right: 1rem;\n            margin-top: 0.25rem; \n        }\n    }\n}\n\n.edit-all-secondrow{\n    display: flex;\n    width: 100% !important;\n    margin-top: 1rem;\n    align-content: flex-end;\n    .dropdown-search{\n        height: 10%;\n        margin-right: 1rem !important;       \n        margin-top: 0.7rem !important;  \n    }\n    .textfield-OI{\n        width: 45% !important;\n        margin-right: 1rem !important;       \n        \n        // background-color: #0FC6EE;\n        // margin-top: 0rem !important;   \n       \n        \n        \n    }\n    .textfield-TD{\n        width: 45% !important;\n        margin-right: 1rem !important;\n        margin-top: 0.7rem !important;  \n        \n    }\n    .edit-textfield-var{\n        width:10% !important;\n        margin-right: 1rem !important;\n        margin-top: 0.7rem !important;  \n      \n    }   \n  \n}\n\n\n\n.modal-expand{\n    margin-top: 1rem;\n}\n\n.custom-dialog{\n    .css-1t1j96h-MuiPaper-root-MuiDialog-paper{\n        background-color: #C3D2EB;\n        // .css-xrd7ll-MuiTypography-root-MuiDialogTitle-root {\n        //     padding: 16px 120px !important;\n        // }\n    }\n}\n.header-textfield {\n    .css-1ff8729-MuiInputBase-root-MuiFilledInput-root {\n        background-color: #D3DDE6 !important;\n    }\n}\n.box-mui{\n    ::-webkit-scrollbar {\n        display: block;\n        width: 0.5rem;\n        height: 50px;\n    }\n    ::-webkit-scrollbar-thumb {\n        background-color: #0FC6EE;\n        min-height: 50px;\n    }\n    \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
